import { Link } from "react-router-dom";

type Crumb = { label: string; to?: string };

type PageHeroProps = {
  eyebrow: string;
  title: string;
  intro?: string;
  crumbs?: Crumb[];
};

export default function PageHero({ eyebrow, title, intro, crumbs }: PageHeroProps) {
  return (
    <section className="relative overflow-hidden bg-gradient-to-b from-cream-100 via-cream-50 to-cream-50">
      <div
        aria-hidden="true"
        className="pointer-events-none absolute -right-32 top-10 h-72 w-72 rounded-full bg-blush-100 opacity-50 blur-3xl"
      />
      <div
        aria-hidden="true"
        className="pointer-events-none absolute -left-24 bottom-0 h-64 w-64 rounded-full bg-sage-100 opacity-60 blur-3xl"
      />

      <div className="section relative py-8 sm:py-20 lg:py-12">
        {crumbs && crumbs.length > 0 && (
          <nav aria-label="Breadcrumb" className="mb-6">
            <ol className="flex flex-wrap items-center gap-x-2 gap-y-1 text-xs text-sage-600">
              {crumbs.map((crumb, idx) => (
                <li key={`${crumb.label}-${idx}`} className="flex items-center gap-2">
                  {crumb.to ? (
                    <Link
                      to={crumb.to}
                      className="uppercase tracking-[0.18em] hover:text-blush-500"
                    >
                      {crumb.label}
                    </Link>
                  ) : (
                    <span className="uppercase tracking-[0.18em] text-sage-700">
                      {crumb.label}
                    </span>
                  )}
                  {idx < crumbs.length - 1 && (
                    <span aria-hidden="true" className="text-sage-400">
                      /
                    </span>
                  )}
                </li>
              ))}
            </ol>
          </nav>
        )}

        <p className="eyebrow">{eyebrow}</p>
        <h1 className="mt-4 max-w-3xl font-serif text-4xl leading-tight text-sage-800 sm:text-5xl">
          {title}
        </h1>
        {intro && (
          <p className="mt-6 max-w-2xl text-base leading-relaxed text-sage-700/90 sm:text-lg">
            {intro}
          </p>
        )}
      </div>
    </section>
  );
}
